import { Button, Input, Table } from "antd";
import React, { useEffect, useState } from "react";
import VehicleServices from "../../../../services/vehicle.services";
import catchErrorFunction from "../../../../utils/tms-catch-error/tms-catch-error";

const SmAccessGates = ({ router }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);

  const handleCancel = () => {
    setName("");
    setDescription("");
    setSubmitLoading(false);
  };

  const handleSubmit = async () => {
    setSubmitLoading(true);
    try {
      await VehicleServices.createAccessGates({ name, description });
      handleCancel();
      fetchAccessGates();
    } catch (error) {
      catchErrorFunction(error, "Failed to create walker tag serials", router);
    } finally {
      setSubmitLoading(false);
    }
  };

  const fetchAccessGates = async () => {
    setLoading(true);
    try {
      const response = await VehicleServices.getAccessGates();
      setTableData(response);
      setTotal(response.total);
      setLoading(false);
    } catch (error) {
      catchErrorFunction(error, "Failed to fetch access gates", router);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccessGates();
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   key: "action",
    //   render: (_, record) => (
    //     <Button
    //       type="primary"
    //       onClick={() => {
    //         // Handle edit action
    //       }}
    //     >
    //       Edit
    //     </Button>
    //   ),
    // },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <label style={{ textAlign: "left" }}>Name</label>
          <Input
            placeholder="Name"
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <label style={{ textAlign: "left" }}>Description</label>
          <Input
            placeholder="Description"
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          />
        </div>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button type="primary" onClick={handleSubmit} loading={submitLoading}>
          Submit
        </Button>
      </div>
      <br />

      <div>
        <Table
          dataSource={tableData}
          loading={loading}
          columns={columns}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default SmAccessGates;
